import * as R from 'ramda';

export default function FunctionController(
  $q,
  $scope,
  $rootScope,
  $filter,
  $timeout,
  alerts,
  loaderService,
  emDataService,
  emSharedModelService,
  ssDialogService,
  confirmDialog,
  editFunctionDialog
) {
  const vm = this;

  vm.hasData = false;
  vm.isExpanded = false;
  vm.canExpand = true;

  // NOTE: We filter these collections in list view, and not in the edit dialog
  // So to support both situations, we watch these scope variables
  // instead of the function.* collections which should not be filtered
  vm.functionITAssetTypes = [];
  vm.functionNonITAssetTypes = [];
  vm.functionVendors = [];

  vm.handleExpandFunction = _handleExpandFunction;
  vm.handleEditFunction = _handleEditFunction;
  vm.handleDeleteFunction = _handleDeleteFunction;

  _activate();

  /** ******************************************
   * Event Handlers
   *
   */
    function _handleExpandFunction() {
    if (vm.canExpand && !vm.isEdit) {
      if (!vm.isExpanded) {
        loaderService.showViewLoader = true;
        _getFunctionDetails().then(() => {
          loaderService.showViewLoader = false;
          vm.isExpanded = true;
        });
      } else {
        vm.isExpanded = false;
      }
    }
  }

  function _handleEditFunction($event) {
    loaderService.showViewLoader = true;
    _getFunctionDetails().then(() => {
      loaderService.showViewLoader = false;
      _showEditFunctionDialog($event);
    });
  }

  function _handleDeleteFunction($event) {
    return _showConfirmDeleteDialog($event);
  }

  /** ******************************************
   * Private Functions
   *
   */

  function _activate() {
    $scope.$on('expandFunction', ($event, expandFunctionArgs) => {
      if (vm.function.functionId === expandFunctionArgs.functionId) {
        vm.isExpanded = true;
      }
    });

     $scope.$on('collapseFunction', ($event, expandFunctionArgs) => {
        if (vm.function.functionId === expandFunctionArgs.functionId) {
          vm.isExpanded = false;
        }
      }
    );
    $scope.$emit('functionDirectiveEventsSet');

    $rootScope.$on('refreshFunction', ($event, refreshFunctionArgs) => {
      if (vm.function.functionId === refreshFunctionArgs.functionId && vm.isExpanded) {
        vm.isExpanded = false;
        _handleExpandFunction();
      }
    });

    _setMissingPermission();

    _filterFunctionDetails(vm.function);
    loaderService.showViewLoader = false;
  }

  function _getFunctionDetails() {
    return emSharedModelService.getFunction(vm.function.functionId, true)
      .then((functionObj) => {
        angular.extend(vm.function, functionObj);
        _setMissingPermission();
        _filterFunctionDetails(vm.function);
      });
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    emSharedModelService.deleteFunction(vm.function)
      .then(() => {
        loaderService.showViewLoader = false;
        // deleteCallback is wrapped in a function by Angular
        vm.deleteCallback()(vm.function);
        alerts.success(`The Function "${vm.function.name}" has successfully been deleted.`);
        _closeDeleteDialog();
      });
  }

  function _showEditFunctionDialog($event) {
    ssDialogService.dialogs.enterpriseModeling.editFunctionDialog = ssDialogService.alert(
      editFunctionDialog.getOptions($event, {
        customerId: vm.customerId,
        department: vm.department,
        process: vm.process,
        functionObj: vm.function,
        addCallback: null,
        updateCallback: _handleUpdatedCallback,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editFunctionDialog);
  }

  function _handleUpdatedCallback(functionObj, processDeptChanged) {
    if(processDeptChanged)
    {
      _broadcastMoveChanges(functionObj);
    } else {
      _filterFunctionDetails(functionObj);
    }
    
  }

  function _showConfirmDeleteDialog($event) {
    ssDialogService.dialogs.enterpriseModeling.deleteFunctionConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Function?',
        message: `Are you sure you want to delete function "${vm.function.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _closeDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.deleteFunctionConfirmDialog);
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.deleteFunctionConfirmDialog);
  }

  function _filterFunctionDetails(functionObj) {
    vm.functionITAssetTypes = _filterOptions(functionObj.functionITAssetTypes);
    vm.functionNonITAssetTypes = _filterOptions(functionObj.functionNonITAssetTypes);
    vm.functionVendors = _filterOptions(functionObj.functionVendors);

    vm.functionVendors.forEach((item) => {
      item.selectedFunctionProducts = _filterOptions(item.functionProducts);
    });

    vm.vendorCount = vm.functionVendors.length;
    vm.assetCount = vm.functionITAssetTypes.length + vm.functionNonITAssetTypes.length;
  }

  function _filterOptions(options) {
    if (!vm.isEdit) {
      return $filter('filter')(options, { isSelected: true, });
    }
    return options;
  }

  function _broadcastMoveChanges(functionObj) {
    $rootScope.$broadcast('moveDepartmentRefresh', { departmentId: functionObj.departmentId, processId: functionObj.processId });
  }

  function _setMissingPermission() {
    // Set missing permissions
    if ((vm.function.canDelete === null) || (vm.function.canDelete === undefined)) {
      vm.function.canDelete = vm.function.canDeleteFunction;
    }
    if ((vm.function.canEdit === null) || (vm.function.canEdit === undefined)) {
      vm.function.canEdit = vm.function.canEditFunction;
    }
  }
}

FunctionController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  '$filter',
  '$timeout',
  'alerts',
  'loaderService',
  'emDataService',
  'emSharedModelService',
  'ssDialogService',
  'confirmDialog',
  'editFunctionDialog'
];
